<template>
  <div>
    <span v-if="data.column.field === 'parentName'">
      <div class="d-flex justify-content-between">
        <span class="text-break">
          {{ data.row.parentName }}
        </span>
        <div class="d-flex align-items-center">
          <b-button
            v-b-modal.industry-modal
            variant="link"
            class="p-0"
            @click="setIndustryModel(data.row)"
          >
            <GjIcon
              name="Edit"
              class="text-primary"
            />
          </b-button>
          <b-button
            v-b-modal.modal-delete-industry
            variant="link"
            class="p-0"
            @click="deleteIndustry(data.row)"
          >
            <GjIcon
              name="Delete"
              class="text-danger"
            />
          </b-button>
        </div>
      </div>
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const deleteIndustry = industryModel => {
      const model = { ...industryModel }
      store.commit('DELETE_INDUSTRY_MODEL', model)
    }
    const setIndustryModel = industryModel => {
      const model = { ...industryModel }
      store.commit('SET_INDUSTRY_MODEL', model)
    }
    return { deleteIndustry, setIndustryModel }
  },
}
</script>
